module.exports = __webpack_public_path__ + "img/2.1-Pivot-Values.db4cc320.png";